module.exports = __webpack_public_path__ + "img/process_pay_fee.2cc3197b.svg";